const { getElements } = window.BAO.Utils
class KlevuSorting extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    if (this.els?.sort.exists) {
      this.els.sort.elements.forEach(sortEl => {
        this.listeners.add(sortEl, 'change', this.changeSort.bind(this))
      })
    }
  }

  changeSort (event) {
    const sortValue = event.target.value
    const klevuSortOptions = getElements('.kuSort')

    if (!klevuSortOptions) return

    const selectedOption = klevuSortOptions.find(
      sortEl => sortEl.dataset.value === sortValue,
    )

    if (selectedOption) selectedOption.click()
  }
}

if (!customElements.get('klevu-sorting')) {
  customElements.define('klevu-sorting', KlevuSorting)
}
